module.exports = __webpack_public_path__ + "static/media/maintenance-bg.49ae8bf9.png";